import React, { Component } from "react";
import styled from "styled-components";

import {
  institutionsName,
  institutionsType,
} from "@/database/institutions.json";

import HeaderImg from "@/assets/homePage/header.png";

const Div = styled.div`
  width: 100%;
  height: 40rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-image: ${(props) => `url(${props.headerImg})`};
  background-size: cover;
  background-position: center center;

  .institutions-container {
    width: 120rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .institutions-name {
      color: white;
      font-size: 4rem;
      padding: 2rem 0;
    }

    .institutions-type {
      color: white;
      font-size: 3rem;
      font-weight: lighter;
    }
  }
`;

class HeaderImage extends Component {
  render() {
    return (
      <Div headerImg={HeaderImg}>
        <div className="institutions-container">
          <div className="institutions-name">{institutionsName}</div>
          <div className="institutions-type">{institutionsType}</div>
        </div>
      </Div>
    );
  }
}

export default HeaderImage;
